import Biology from '~/pages/onboarding/intro/libs/components/Biology'
import { eventLogger } from '~/shared/services/eventLogger'
import { TPageProps } from '~/shared/types/commonTypes'
import { appHistory } from '~/shared/utils'

const IntroBiology = ({ nextPagePath }: TPageProps) => {
  const handleNextPageClick = () => {
    eventLogger.logFirstPageCompleted()
    appHistory.goTo(nextPagePath)
  }

  return <Biology onCLick={handleNextPageClick} />
}

export default IntroBiology
